import React from "react";
import ContactUs from "../common/ContactUs";
import { FaCheckCircle } from "react-icons/fa";

const AboutAndContactInfro = () => {
  return (
    <div className="container px-4 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">
        {/* About Section - Left Side */}
        <div className="md:col-span-3 mx-2 sm:mx-4 bg-white rounded-2xl p-6 sm:p-8 shadow-md">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 sm:mb-8 border-b-4 border-orange-500 inline-block pb-2">
            ABOUT US
          </h1>

          <ul className="grid gap-3 sm:gap-4 md:gap-5 text-gray-700 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed list-none w-full xl:w-[95%] text-justify">
            <li className="flex items-start gap-2 sm:gap-3">
              <FaCheckCircle className="text-orange-500 mt-1 flex-shrink-0 text-lg sm:text-xl" />
              <span>
                Wide range of services including denting, painting, brake
                repairs, oil changes, and mechanical work.
              </span>
            </li>
            <li className="flex items-start gap-2 sm:gap-3">
              <FaCheckCircle className="text-orange-500 mt-1 flex-shrink-0 text-lg sm:text-xl" />
              <span>
                High-quality vehicle servicing, maintenance, and repairs for all
                makes and models.
              </span>
            </li>
            <li className="flex items-start gap-2 sm:gap-3">
              <FaCheckCircle className="text-orange-500 mt-1 flex-shrink-0 text-lg sm:text-xl" />
              <span>
                Affordable quality service with a personal touch for every
                customer.
              </span>
            </li>
            <li className="flex items-start gap-2 sm:gap-3">
              <FaCheckCircle className="text-orange-500 mt-1 flex-shrink-0 text-lg sm:text-xl" />
              <span>
                Workshops equipped with the latest diagnostic tools to reduce
                troubleshooting time.
              </span>
            </li>
            <li className="flex items-start gap-2 sm:gap-3">
              <FaCheckCircle className="text-orange-500 mt-1 flex-shrink-0 text-lg sm:text-xl" />
              <span>
                Reliable and effective service and maintenance without affecting
                your manufacturer’s warranty.
              </span>
            </li>
            <li className="flex items-start gap-2 sm:gap-3">
              <FaCheckCircle className="text-orange-500 mt-1 flex-shrink-0 text-lg sm:text-xl" />
              <span>
                Skilled technicians using advanced technology and equipment to
                diagnose and repair issues.
              </span>
            </li>
            <li className="flex items-start gap-2 sm:gap-3">
              <FaCheckCircle className="text-orange-500 mt-1 flex-shrink-0 text-lg sm:text-xl" />
              <span>
                Customer-first approach ensuring transparency and honest
                service.
              </span>
            </li>
            <li className="flex items-start gap-2 sm:gap-3">
              <FaCheckCircle className="text-orange-500 mt-1 flex-shrink-0 text-lg sm:text-xl" />
              <span>
                Quick turnaround time to get your vehicle back on the road as
                soon as possible.
              </span>
            </li>
          </ul>
        </div>

        {/* Contact Section - Right Side */}
        <div className="md:col-span-2 w-full bg-gray-50">
          <ContactUs />
        </div>
      </div>
    </div>
  );
};

export default AboutAndContactInfro;
